import { useCallback, useEffect, useState, Fragment } from "react";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "components/shared/BackButton";
import {
  StyledStack,
  ButtonContainer,
  StyledTitle,
} from "./EditCategory.style";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckIcon from "@mui/icons-material/Check";
import DrawerCM from "components/shared/Drawer";
import DeleteIcon from "@mui/icons-material/Delete";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import Toast from "helper/toast";
import DeleteModal from "components/shared/Modal/Delete";
import { CategorySchema } from "validations";
import {
  getDesignInfoRequest,
  deleteDesignRequest,
  updateDesignRequest,
} from "api/requests";

export default function EditCategory() {
  const navigate = useNavigate();
  const params = useParams();
  const { request, loading } = useHttp();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(CategorySchema),
    defaultValues: {
      title: "",
    },
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [designData, setDesignData] = useState({});

  const handelShowModal = () => setShowDeleteModal((state) => !state);

  const onSubmit = async (data) => {
    const res = await request({
      url: () => updateDesignRequest({ id: params.designId, ...data }),
    });

    if (res) Toast({ type: "success", title: "ویرایش طرح" });
  };

  const handelDelete = async () => {
    const res = await request({
      url: deleteDesignRequest,
      values: params.designId,
    });

    if (res) Toast({ type: "success", title: "حذف" });
    navigate(-1);
  };

  const getDesign = useCallback(async () => {
    let res = await request({
      url: getDesignInfoRequest,
      values: params.designId,
    });
    setDesignData(res);

    if (res) {
      reset({
        title: res.title,
      });
    }
  }, [request, params.designId, reset]);

  useEffect(() => {
    getDesign();
  }, [getDesign]);

  return (
    <DrawerCM title="ویرایش طرح">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>ویرایش طرح</StyledTitle>
            <Grid container>
              <Grid item md={6} xs={12} p={1.5}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="title"
                  {...register("title")}
                  error={Boolean(errors.title)}
                  helpertext={errors.title?.message}
                />
              </Grid>
              <Grid item md={6} xs={12} p={1.5}>
                <TextField
                  label="سردسته"
                  variant="outlined"
                  fullWidth
                  value={designData.category?.title}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              <ButtonContainer>
                <Button
                  color="error"
                  startIcon={<DeleteIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handelShowModal}
                >
                  حذف
                </Button>
                <Button
                  color="success"
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1, mr: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
          <DeleteModal
            show={showDeleteModal}
            onClose={handelShowModal}
            onDelete={handelDelete}
          />
        </Fragment>
      )}
    </DrawerCM>
  );
}
